export const LOADING_INDICATOR = 'LOADING_INDICATOR';
export const TOAST_SUCCESS = 'TOAST_SUCCESS';
export const TOAST_ERROR = 'TOAST_ERROR';
export const UPDATE_DISPLAYNAME_AND_AVATAR = 'UPDATE_DISPLAYNAME_AND_AVATAR';
export const PUBLISH_PROJECT_INFORMATION = 'PUBLISH_PROJECT_INFORMATION';
export const SYNC_USER_PROFILE = 'SYNC_USER_PROFILE';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';

export const ROOT_TOAST_SUCCESS = 'ROOT_TOAST_SUCCESS';
export const ROOT_TOAST_ERROR = 'ROOT_TOAST_ERROR';

export const CHANGE_ROLE = 'CHANGE_ROLE';

export const REASSIGN_PROJECT_START = 'REASSIGN_PROJECT_START';

export const REASSIGN_PROJECT_FINISHED = 'REASSIGN_PROJECT_FINISHED';
export const ACCESS_DENIED_ERROR = 'ACCESS_DENIED_ERROR';
export const RESET_HANDLING_ERROR = 'RESET_HANDLING_ERROR';

export const HOMEOWNER_CHANGE_EMAIL = 'HOMEOWNER_CHANGE_EMAIL';

export const USER_SUSPENDED = 'USER_SUSPENDED';
export const USER_LOCKED = 'USER_LOCKED';

export const REASSIGN_MULTIPLE_RFS_START = 'REASSIGN_MULTIPLE_RFS_START';

export const REASSIGN_MULTIPLE_RFS_FINISHED = 'REASSIGN_MULTIPLE_RFS_FINISHED';

export const REASSIGN_MULTIPLE_WORK_ORDER_START =
  'REASSIGN_MULTIPLE_WORK_ORDER_START';

export const REASSIGN_MULTIPLE_WORK_ORDER_FINISHED =
  'REASSIGN_MULTIPLE_WORK_ORDER_FINISHED';

export const IMPORT_REQUEST_FOR_SERVICES_PROGRESS_UPDATE =
  'IMPORT_REQUEST_FOR_SERVICES_PROGRESS_UPDATE';

export const IMPORT_WORK_ORDERS_PROGRESS_UPDATE =
  'IMPORT_WORK_ORDERS_PROGRESS_UPDATE';

export const IMPORT_PURCHASE_ORDERS_PROGRESS_UPDATE =
  'IMPORT_PURCHASE_ORDERS_PROGRESS_UPDATE';



// WEBPACK FOOTER //
// ./src/services/constants.js